module.exports = __webpack_public_path__ + "img/12_26@2x.ca8e37de.png";